<template>
  <div>
    <vue-good-table
      :pagination-options="{
        enabled: true,
        perPage: 5,
        perPageDropdown: [5, 10],
      }"
      :columns="columns"
      :rows="rows"
    />
  </div>
</template>

<script>
export default {
  props: ['rows'],
  data() {
    return {
      columns: [
        {
          label: 'Nama',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'No Whatsapp',
          field: 'number',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Tanggal Lahir',
          field: 'birth_date',
          filterOptions: {
            enabled: true,
          },
          formatFn: (value) => {
            if (!value) return '-'
            const date = new Date(value)
            if (isNaN(date.getTime())) {
              return value
            }
            return date.toLocaleDateString('id-ID')
          },
        },
      ],
    }
  },
}
</script>
